import * as React from 'react';
import styled, { css } from 'styled-components';

export interface AcceptIconProps {
  className?: string;
  noHover?: boolean;
  onClick?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

export const AcceptIcon: React.FC<AcceptIconProps> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    className={props.className}
    onClick={props.onClick}
  >
    <path
      className="circle"
      d="M10 0L10 0c5.5 0 10 4.5 10 10l0 0c0 5.5-4.5 10-10 10l0 0C4.5 20 0 15.5 0 10l0 0C0 4.5 4.5 0 10 0z"
    />
    <path
      className="line"
      d="M9.3 12c-0.1 0-0.2 0-0.3-0.1l-1.8-1.7c-0.2-0.2-0.2-0.5 0-0.7 0.2-0.2 0.5-0.2 0.7 0l1.5 1.4 2.8-2.7c0.2-0.2 0.5-0.2 0.7 0 0.2 0.2 0.2 0.5 0 0.7l-3.2 3C9.6 12 9.4 12 9.3 12z"
    />
  </svg>
);

export default styled(AcceptIcon)`
  ${(props) =>
    props.noHover
      ? null
      : css`
          cursor: pointer;

          &:hover {
            .circle {
              fill: ${({ theme }) => theme.colors.successDark};
            }
          }
        `}

  .circle {
    fill: ${({ theme }) => theme.colors.successLight};
    transition: fill
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};
  }

  .line {
    fill: ${({ theme }) => theme.colors.successText};
    transition: fill
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};
  }
`;
